/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `Outside Hitter` - Outside Hitter
* `Opposite Hitter` - Opposite Hitter
* `Middle Blocker` - Middle Blocker
* `Setter` - Setter
* `Libero` - Libero
* `Defensive Specialist` - Defensive Specialist
* `Unspecified` - Unspecified
 */
export type SecondaryPositionVolleyballEnum = typeof SecondaryPositionVolleyballEnum[keyof typeof SecondaryPositionVolleyballEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SecondaryPositionVolleyballEnum = {
  Outside_Hitter: 'Outside Hitter',
  Opposite_Hitter: 'Opposite Hitter',
  Middle_Blocker: 'Middle Blocker',
  Setter: 'Setter',
  Libero: 'Libero',
  Defensive_Specialist: 'Defensive Specialist',
  Unspecified: 'Unspecified',
} as const;
